import { constants } from '@clubmed/utils';

const { COLORS, COLORS_LIST, COMPLEMENTARY_COLORS } = constants;

export { COLORS, COLORS_LIST, COMPLEMENTARY_COLORS };
